import Head from "next/head";
import { SimplePageLayout } from "~/layouts/SimplePageLayout";
import { assertsString } from "~/submodules/assertsString";
import { getInitialPageProps } from "~/store";
import { nowdoApi } from "~/hooks/rtk-query-api";
import { Classroom } from "~/generated/rtk-query/nowdo-live-api.generated";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { redirect } from "~/submodules/redirect";

function LinkClassroomPage({ props: { classroom, link } }: { props: { classroom: Classroom; link: string } }) {
  return (
    <div>
      <Head>
        <title>{classroom.name}</title>
        <meta property="og:title" content={classroom.name} />
        <meta property="og:url" content={link} />
        <meta property="og:description" content={classroom.description} />
        <meta
          property="og:image"
          content={`${process.env.NEXT_PUBLIC_IMAGE_SERVER_URL}/ogp/classrooms/${classroom.id}.png`}
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@nowdoofficial" />
        <script
          dangerouslySetInnerHTML={{
            __html: `window.location.href = '${link}';`,
          }}
        />
      </Head>
      <div />
    </div>
  );
}

LinkClassroomPage.Layout = SimplePageLayout;

LinkClassroomPage.getInitialProps = getInitialPageProps((store) => async (context) => {
  try {
    const classroomId = context.query?.id;
    assertsString(classroomId);

    const [{ data: classroom, error: classroomError }, { data: link, error: linkError }] = await Promise.all([
      store.dispatch(nowdoApi.endpoints.getClassroom.initiate({ id: classroomId })),
      store.dispatch(nowdoApi.endpoints.getClassroomLink.initiate({ id: classroomId })),
    ]);
    if (classroomError) {
      if ((classroomError as FetchBaseQueryError).status === 404) {
        redirect(context, "/404");
        return {};
      } else {
        redirect(context, "/500");
        return {};
      }
    }
    if (linkError) {
      if ((linkError as FetchBaseQueryError).status === 404) {
        redirect(context, "/404");
        return {};
      } else {
        redirect(context, "/500");
        return {};
      }
    }

    return {
      props: {
        classroom,
        link: link?.url,
      },
    };
  } catch (e) {
    return {
      props: {},
      notFound: true,
    };
  }
});

export default LinkClassroomPage;
